module.exports = __webpack_public_path__ + "static/media/accessory-70.c8d55336.png";